import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  RastreamentoPedidoHistoricoOutput,
  RastreamentoPedidosInput,
  RastreamentoPedidosOutput,
  RastreamentoPedidoTrackingOutput
} from 'src/app/@shared/models/rastreamento.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class RastreamentoService {

  constructor(private http: HttpClient) { }

  selecionarRastreamentoPedidos(filter: RastreamentoPedidosInput):
    Observable<RastreamentoPedidosOutput[]> {
      return this.http
        .post<RastreamentoPedidosOutput[]>(`ConsultaDetalhes/SelecionarRastreamentoPedidos?`
        + `${filter.codRastreioNumPedido ? `codRastreioNumPedido=${filter.codRastreioNumPedido}&` : ''}`
        + `${filter.cpf ? `cpf=${filter.cpf}&` : ''}`
        + `${filter.itensPorPagina ? `itensPorPagina=${filter.itensPorPagina}&` : ''}`
        + `${filter.paginaAtual ? `paginaAtual=${filter.paginaAtual}&` : ''}`,
        httpOptions
      );
  }

  selecionarRastreamentoPedidoTracking(pedidoId: number):
    Observable<RastreamentoPedidoTrackingOutput> {
      return this.http
        .post<RastreamentoPedidoTrackingOutput>(`ConsultaDetalhes/SelecionarRastreamentoPedidoTracking/${pedidoId}`, httpOptions);
  }

  selecionarRastreamentoPedidoHistorico(pedidoId: number):
    Observable<RastreamentoPedidoHistoricoOutput[]> {
      return this.http
        .get<RastreamentoPedidoHistoricoOutput[]>(`ConsultaDetalhes/SelecionarRastreamentoPedidoHistorico/${pedidoId}`, httpOptions);
  }
}
